import { motion } from "framer-motion";

const SMOKE = "/brand/product/box-top.jpg";

const chapters = [
  {
    num: "01",
    title: "Born In The Culture",
    body: "Hot Packz Grabba wasn't made in a boardroom. It came up from the block, for the smokers, the hustlers, and everybody who keeps it authentic.",
  },
  {
    num: "02",
    title: "Our Proprietary Blend",
    body: "The edge is in the mix. A proprietary blend of hand-picked grabba leaf strains, crushed to spec. It's the exact flavor and character that makes Hot Packz, Hot Packz.",
  },
  {
    num: "03",
    title: "Crushed To Perfection",
    body: "Finely crushed grabba with consistent flavor and a consistent burn, pack after pack. No shortcuts, no compromises.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Manifesto() {
  return (
    <section id="story" data-testid="manifesto" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={SMOKE} alt="" className="w-full h-full object-cover opacity-[0.08]" />
        <div className="absolute inset-0 bg-ink/60" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze mb-4">The Manifesto</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            More than a <span className="text-fire">grabba</span>. A movement.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-px bg-surface-border border border-surface-border">
          {chapters.map((c, i) => (
            <motion.article
              key={c.num}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="group bg-ink p-8 sm:p-10 hover:bg-surface transition-colors duration-300"
            >
              <span className="font-display text-outline-gold text-6xl block mb-6 group-hover:text-gold transition-colors duration-300">
                {c.num}
              </span>
              <h3 className="font-heading uppercase text-xl sm:text-2xl mb-4 tracking-tight">{c.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-sm sm:text-base">{c.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
